import { useCallback, useEffect, useState } from 'react';

// Types
import { fetchEmployeeMetrics } from 'Shared/api/employee.api';
import { PiEmployeeType } from 'Shared/types/PiEmployee.type';

export type ReviewCycleEmployeeMetrics = {
  totalEmployees: number;
  nonPerformUsersCount: number;
  missingManagers: number;
};

export const useReviewCycleEmployeeMetricsFetch = () => {
  const [isFetching, setIsFetching] = useState<boolean>(true);
  const [employeeMetrics, setEmployeeMetrics] = useState<ReviewCycleEmployeeMetrics>({
    totalEmployees: 0,
    nonPerformUsersCount: 0,
    missingManagers: 0,
  });

  const [nonPerformUsers, setNonPerformUsers] = useState<PiEmployeeType[]>(null);
  const [error, setError] = useState(null);

  const fetchMetrics = useCallback(() => {
    setIsFetching(true);
    fetchEmployeeMetrics()
      .then(response => {
        if (response.status != 200) {
          throw new Error('Employee Metrics failed to load');
        }

        setEmployeeMetrics(response.data.data.attributes);
        setNonPerformUsers(response.data.included.map(include => include.attributes) || []);
      })
      .catch(error => setError(error))
      .finally(() => setIsFetching(false));
  }, []);

  useEffect(() => {
    fetchMetrics();
  }, [fetchMetrics]);

  return { isFetching, error, employeeMetrics, nonPerformUsers, fetchMetrics };
};
